// import { useEffect, useState } from 'react';
// import { Col, Collapse, message, Popconfirm, Row, Select, Space, Table, Divider, Button, Card, DatePicker, Dropdown, Typography, Input } from 'antd';
// import { dateFormat, menuLinks, notifyMessages, tablePageSize } from '../../utils/constants';
// import { useDispatch, useSelector } from 'react-redux';
// import { DeleteFilled, WarningOutlined, PlusOutlined, DownOutlined, MessageOutlined, EyeOutlined } from "@ant-design/icons";
// import { useCurrentUserContext } from '../../context/currentUserContext';
// import { Link } from "react-router-dom";
// import "./distinteDocuments.scss";
// import { PageHeader } from '../../components/common/pageHeader';
// import { downloadSelectedDocPdfFiles, handleDateConvertForApis } from '../../utils/functions';
// import DistinteDocumentServices from '../../services/distinteDocumentServices';
// import dayjs from 'dayjs';
// import * as XLSX from 'xlsx-js-style';
// import * as FileSaver from "file-saver";
// import { group1Rights, group2Rights } from '../../configs/auth/roleRights';
// import { fetchSuppliersList } from '../../state/slices/suppliersListSlice';
// import CreateDocumentFlux from '../documents/newDocumentFlux';
// import DocumentsServices from '../../services/documentsServices';

// const { RangePicker } = DatePicker;
// const { Text } = Typography;

// const DistinteDocumentList = () => {

//   let filtersInitValues = {
//     monthFrom: null,
//     monthTo: null,
//     monthRange: null,
//     regionId: null,
//     flux: "",
//     documentTypeDistinte: null,

//     dateAddedFrom: null,
//     dateAddedTo: null,
//     dateAddedRange: null,

//     lastUpdatedDateFrom: null,
//     lastUpdatedDateTo: null,
//     dateUpdatedRange: null
//   };

//   const dispatch = useDispatch();
//   const { currentUser } = useCurrentUserContext();
//   const regionsList = useSelector(state => state.regions.regions);

//   const [documents, setDocuments] = useState([]);
//   const [loadingData, setLoadingData] = useState(false);
//   const [pageNumber, setPageNumber] = useState(1);
//   const [sorterColumn, setSorterColumn] = useState("");
//   const [filterValues, setFilterValues] = useState(filtersInitValues);
//   const [totalCountRecords, setTotalCountRecords] = useState(null);
//   const [showDocumentFluxModal, setShowDocumentFluxModal] = useState(false);
//   const [loadingFlux, setLoadingFlux] = useState(false);
//   const documentTypesDistinteList = useSelector(state => state.docTypes.docTypesDistinte);

//   const [selectedRowKeys, setSelectedRowKeys] = useState([]);
//   const [hasAllSelection, setHasAllSelection] = useState(false);
//   const [loadingExcelDataExport, setLoadingExcelDataExport] = useState(false);

//   useEffect(() => {
//     if (!currentUser) return;
//     dispatch(fetchSuppliersList(currentUser.lastSelectedCategory, false, currentUser.id));
//   }, [dispatch, currentUser]);

//   useEffect(() => {
//     getDistinteDocuments(filterValues);
//   }, [pageNumber,
//     sorterColumn,
//     filterValues.monthRange,
//     filterValues.regionId,
//     filterValues.documentTypeDistinte,
//     filterValues.dateAddedRange,
//     filterValues.dateUpdatedRange]
//   );


//   const getDistinteDocuments = async (filterValues) => {

//     let filterObj = filterValues;
//     filterObj["pageNumber"] = pageNumber;
//     filterObj["sortColumn"] = sorterColumn;
//     filterObj["userID"] = currentUser.id;

//     console.log("filterObj", filterObj)
//     setLoadingData(true)
//     try {
//       const respData = await DistinteDocumentServices.getDistinteDocuments(filterObj);

//       if (respData.success) {
//         let result = respData.responseObject.value.document_Distinte_DTO;
//         setDocuments(result);

//         if (result && result.length > 0)
//           setTotalCountRecords(result[0].totalCount);

//         if (hasAllSelection) {
//           setSelectedRowKeys(result.map(doc => doc.id));
//         }
//       }

//       setLoadingData(false);

//     } catch (error) {
//       message.error(notifyMessages.errorAccured);
//       setLoadingData(false);
//     }
//   };

//   const getSelectedDocuments = async () => {
//     const docIds = hasAllSelection ? null : selectedRowKeys.join(",");
//     const payload = {
//       sortColumn: sorterColumn && sorterColumn.trim() !== "" ? sorterColumn : "id",
//       docIDsList: docIds,
//       userID: currentUser.id
//     };
//     setLoadingExcelDataExport(true);
//     try {
//       const respData = await DistinteDocumentServices.getSelectedDocumentsList(payload);
//       if (respData.success) {

//         let result = respData.responseObject.value.documents;
//         if (result && result.length > 0) {
//           createExcelDataFile(result);
//         }
//         handleDeselectAll();
//         setLoadingExcelDataExport(false);
//       } else {
//         message.error(notifyMessages.errorAccured);
//         setLoadingExcelDataExport(false);
//       }
//     } catch (error) {
//       message.error(notifyMessages.errorAccured);
//       setLoadingExcelDataExport(false);
//     }
//   };

//   const getDocumentAttachments = async () => {
//     const docIds = hasAllSelection ? null : selectedRowKeys.join(",");
//     setLoadingExcelDataExport(true)
//     let filterObj = filterValues;
//     filterObj["docIDsList"] = docIds;
//     filterObj['userID'] = currentUser.id;
//     try {
//       const respData = await DistinteDocumentServices.getDocumentListAttachments(filterObj);
//       if (respData.success) {
//         let result = respData.responseObject.value.documents;
//         if (result && result.length > 0) {
//           downloadSelectedDocPdfFiles(result, "Esportazione-Portale");
//         }
//         else {
//           message.info(notifyMessages.noFileFound);
//         }
//         handleDeselectAll();
//       }
//       setLoadingExcelDataExport(false);
//     } catch (error) {
//       message.error(notifyMessages.errorAccured);
//       setLoadingExcelDataExport(false);
//     }
//   };

//   const createExcelDataFile = (data) => {
//     if (!data || data.length === 0) {
//       message.info("Nessun dato trovato");
//       return;
//     }
//     let formattedDocData = data.map((item) => ({
//       Month: item.month,
//       DateAdded: item.dateAdded ? dayjs(item.dateAdded).format(dateFormat) : "",
//       RegionName: item.regionName,
//       flux: item.flux,
//       documentTypeDistinteName: item.documentTypeDistinteName
//     }));

//     const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
//     const fileExtension = ".xlsx";
//     const fileName = `ESPORTAZIONE-PORTALE-${dayjs().format(dateFormat)}`;
//     // Define headers
//     const headers = [["Mese", "Data Caricamento", "Regione", "Batch", "Tipo"],
//     ];
//     const ws = XLSX.utils.json_to_sheet([]);
//     XLSX.utils.sheet_add_json(ws, formattedDocData, { origin: "A2", skipHeader: true });
//     XLSX.utils.sheet_add_aoa(ws, headers);
//     const wb = { Sheets: { "Esportazione Fatture": ws }, SheetNames: ["Esportazione Fatture"] };
//     // Set column width
//     ws["!cols"] = Array(25).fill({ wpx: 200 });
//     // Apply bold style to headers
//     for (let key in ws) {
//       if (typeof ws[key] !== "object") continue;
//       let cell = XLSX.utils.decode_cell(key);
//       if (cell.r === 1) {
//         let p = key.replace("2", "1");
//         ws[p].s = { font: { bold: true } };
//       }
//     }
//     const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
//     const dataBlob = new Blob([excelBuffer], { type: fileType });
//     FileSaver.saveAs(dataBlob, fileName + fileExtension);
//   };

//   const onPageOrOrderChange = (pagination, filters, sorter) => {
//     setPageNumber(pagination.current);
//     if (sorter && sorter.field) {
//       let sorterQuote = "";
//       if (sorter.order === "descend") {
//         sorterQuote = "[" + sorter.field + "]" + " " + "DESC";
//       }
//       if (sorter.order === "ascend") {
//         sorterQuote = "[" + sorter.field + "]" + " " + "ASC";
//       }
//       setSorterColumn(sorterQuote);
//     } else {
//       setSorterColumn("");
//     }
//   };

//   const onFilter = () => {
//     getDistinteDocuments(filterValues);
//     setPageNumber(1);
//   };

//   const clearFilters = () => {
//     setPageNumber(1);
//     setFilterValues(filtersInitValues);
//     getDistinteDocuments(filtersInitValues);
//   };

//   const handelFilterChange = (name, value) => {
//     if (name === "dateAdded") {
//       let startDateAdded = handleDateConvertForApis(value[0].$d);
//       let endDateAdded = handleDateConvertForApis(value[1].$d);
//       setFilterValues((prev) => ({ ...prev, dateAddedFrom: startDateAdded }));
//       setFilterValues((prev) => ({ ...prev, dateAddedTo: endDateAdded }));
//       setFilterValues((prev) => ({ ...prev, dateAddedRange: value }));
//     }
//     else if (name === "dateUpdated") {
//       let startDateUpdated = handleDateConvertForApis(value[0].$d);
//       let endDateUpdated = handleDateConvertForApis(value[1].$d);
//       setFilterValues((prev) => ({ ...prev, lastUpdatedDateFrom: startDateUpdated }));
//       setFilterValues((prev) => ({ ...prev, lastUpdatedDateTo: endDateUpdated }));
//       setFilterValues((prev) => ({ ...prev, dateUpdatedRange: value }));
//     }
//     else if (name === "month") {
//       let monthFrom = handleDateConvertForApis(value[0].$d);
//       let monthTo = handleDateConvertForApis(value[1].$d);
//       setFilterValues((prev) => ({ ...prev, monthFrom: monthFrom }));
//       setFilterValues((prev) => ({ ...prev, monthTo: monthTo }));
//       setFilterValues((prev) => ({ ...prev, monthRange: value }));
//     }
//     else {
//       setFilterValues((prev) => ({ ...prev, [name]: value }));
//     }
//   }

//   const onDocumentPdfView = async (documentId) => {
//     message.warning(notifyMessages.generateDocumentPdfLoading);
//     try {
//       const respData = await DistinteDocumentServices.readDocumentPDF(documentId);
//       if (respData.success) {
//         let pdfData = respData.responseObject.value;
//         if (pdfData.documentPdfURI) {
//           // handle and convert base64 to PDF
//           let base64str = pdfData.pdfArray;
//           let binary = atob(base64str.replace(/\s/g, ""));
//           let len = binary.length;
//           let buffer = new ArrayBuffer(len);
//           let view = new Uint8Array(buffer);
//           for (let i = 0; i < len; i++) {
//             view[i] = binary.charCodeAt(i);
//           }
//           // create the blob object with content-type "application/pdf"
//           let blob = new Blob([view], { type: "application/pdf" });
//           let url = URL.createObjectURL(blob);
//           window.open(url, "Document", "width=800,height=600");
//         } else {
//           message.error(notifyMessages.noFileFound);
//         }
//       } else {
//         message.error(notifyMessages.errorAccured);
//       }
//     } catch (error) {
//       message.error(notifyMessages.errorAccured);
//     }
//   };

//   const onRemoveDocument = async (documentId) => {
//     try {
//       const respData = await DistinteDocumentServices.deleteDocument(documentId);
//       if (respData.success) {
//         message.success(notifyMessages.operationSuccess);
//         getDistinteDocuments(filterValues);
//       } else {
//         message.error(notifyMessages.errorAccured);
//       }
//     } catch (error) {
//       message.error(notifyMessages.errorAccured);
//     }
//   };

//   const columns = [
//     {
//       title: "Opzioni",
//       key: "actions",
//       width: "150px",
//       render: (_, record) => (
//         <Space size="middle">
//           <EyeOutlined style={{ color: "#023B72", marginRight: "5px" }} onClick={() => onDocumentPdfView(record.id)} />
//           <MessageOutlined style={{ color: record.notesViewed ? 'blue' : 'green' }} />
//           <Link style={{ color: "#0f4d65" }} to={{ pathname: `${menuLinks.distinte}/view/id/${record.id}` }}>Apri</Link>
//         </Space>
//       ),
//       onCell: () => ({
//         style: {
//           whiteSpace: "nowrap", // prevent wrapping
//         },
//       }),
//       width: 1, // let browser auto-size to content
//     },

//     {
//       title: "Regione",
//       dataIndex: "regionName",
//       key: "regionName",
//       sorter: (a, b) => {
//         a = a.regionName || "";
//         b = b.regionName || "";
//         return a.localeCompare(b);
//       },
//       showSorterTooltip: false,
//       className: 'doc-table-wrap-cell'
//     },
//     {
//       title: "Mese",
//       dataIndex: "month",
//       key: "month",
//       sorter: (a, b) => {
//         const dateA = dayjs(a.month, 'MM');
//         const dateB = dayjs(b.month, 'MM');
//         return dateA.isBefore(dateB) ? -1 : dateA.isAfter(dateB) ? 1 : 0;
//       },
//       showSorterTooltip: false,
//       render: (text, record) => (text ? dayjs(text).format("MM/YYYY") : ""),
//       onCell: () => ({
//         style: {
//           whiteSpace: "nowrap", // prevent wrapping
//         },
//       }),
//       width: 1, // let browser auto-size to content
//       // className: 'doc-table-wrap-cell'
//     },
//     {
//       title: "Batch",
//       dataIndex: "flux",
//       key: "flux",
//       sorter: (a, b) => {
//         a = a.flux || "";
//         b = b.flux || "";
//         return a.localeCompare(b);
//       },
//       showSorterTooltip: false,
//       className: 'doc-table-wrap-cell'
//     },
//     {
//       title: "Tipo",
//       dataIndex: "documentTypeDistinteName",
//       key: "documentTypeDistinteName",
//       sorter: (a, b) => {
//         a = a.documentTypeDistinteName || "";
//         b = b.documentTypeDistinteName || "";
//         return a.localeCompare(b);
//       },
//       showSorterTooltip: false,
//       className: 'doc-table-wrap-cell'
//     },
//     {
//       title: "Data caricamento",
//       dataIndex: "dateAdded",
//       key: "dateAdded",
//       sorter: (a, b) => {
//         a = a.dateAdded || "";
//         b = b.dateAdded || "";
//         return a.localeCompare(b);
//       },
//       showSorterTooltip: false,
//       render: (text) => (text ? dayjs(text).format(dateFormat) : ""),
//       onCell: () => ({
//         style: {
//           whiteSpace: "nowrap", // prevent wrapping
//         },
//       }),
//       width: 1, // let browser auto-size to content
//       // className: 'doc-table-wrap-cell'
//     },
//     {
//       key: "action3",
//       width: "50px",
//       render: (_, record) => {
//         return (
//           <>
//             {group1Rights(currentUser) && (
//               <Popconfirm
//                 placement="topRight"
//                 key="remove"
//                 title="Vuoi eliminare questo documento?"
//                 icon={<WarningOutlined style={{ color: "#f7c924" }} />}
//                 okText="Si"
//                 cancelText="No"
//                 onConfirm={() => onRemoveDocument(record.id)}
//               >
//                 <DeleteFilled style={{ color: "#023B72" }} title={"Elimina Documento"} />
//               </Popconfirm>
//             )}
//           </>
//         );
//       },
//     },
//   ]

//   const totalPages = Math.ceil(totalCountRecords / tablePageSize);

//   const panelItems = [
//     {
//       key: '1',
//       label: `Filtra documenti - Visualizzando ${totalCountRecords ? totalCountRecords : ""} documenti (Pagina: ${pageNumber}/${totalPages})`,
//       children: (
//         <>
//           <Row gutter={{ lg: 24 }}>


//             <Col className="gutter-row mb10" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 4 }}>
//               <Space direction='vertical' style={{ width: "100%" }}>
//                 <span>Mese</span>
//                 <RangePicker
//                   value={filterValues.monthRange}
//                   picker="month"
//                   style={{ width: "100%" }}
//                   format={'MM/YYYY'}
//                   placeholder={["Mese inizio", 'Mese fine']}
//                   onChange={(dates) => handelFilterChange("month", dates)}
//                 />
//               </Space>
//             </Col>

//             <Col className="gutter-row mb10" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 4 }}>
//               <Space direction='vertical' style={{ width: "100%" }}>
//                 <span>Regione</span>
//                 <Select
//                   value={filterValues.regionId}
//                   style={{ width: "100%" }}
//                   showSearch
//                   optionFilterProp="label"
//                   placeholder="Regione"
//                   allowClear={false}
//                   options={regionsList}
//                   onSelect={(value) => handelFilterChange("regionId", value)}
//                 />
//               </Space>
//             </Col>

//             <Col className="gutter-row mb10" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 4 }}>
//               <Space direction='vertical' style={{ width: "100%" }}>
//                 <span>Tipo</span>
//                 <Select
//                   value={filterValues.documentTypeDistinte}
//                   style={{ width: "100%" }}
//                   showSearch
//                   optionFilterProp="label"
//                   placeholder="Tipo"
//                   allowClear={false}
//                   options={documentTypesDistinteList}
//                   onSelect={(value) => handelFilterChange("documentTypeDistinte", value)}
//                 />
//               </Space>
//             </Col>

//             <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 4 }}>
//               <Space direction='vertical' style={{ width: "100%" }}>
//                 <span>Batch</span>
//                 <Input value={filterValues.flux} placeholder='Batch' onChange={(e) => handelFilterChange("flux", e.target.value)} />
//               </Space>
//             </Col>

//             <Col className="gutter-row mb10" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 4 }}>
//               <Space direction='vertical' style={{ width: "100%" }}>
//                 <span>Data caricamento</span>
//                 <RangePicker
//                   value={filterValues.dateAddedRange}
//                   style={{ width: "100%" }}
//                   format={dateFormat}
//                   placeholder={["Data inizio", 'Data fine']}
//                   onChange={(dates) => handelFilterChange("dateAdded", dates)}
//                   allowClear={false}
//                 />
//               </Space>
//             </Col>

//             <Col className="gutter-row mb10" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 4 }}>
//               <Space direction='vertical' style={{ width: "100%" }}>
//                 <span>Data modifica</span>
//                 <RangePicker
//                   value={filterValues.dateUpdatedRange}
//                   style={{ width: "100%" }}
//                   format={dateFormat}
//                   placeholder={["Data inizio", 'Data fine']}
//                   onChange={(dates) => handelFilterChange("dateUpdated", dates)}
//                   allowClear={false}
//                 />
//               </Space>
//             </Col>

//           </Row>
//           <Divider />
//           <Row gutter={{ lg: 24 }}>
//             <Col className="gutter-row fliterButtons" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
//               <Button type="primary" style={{ marginRight: 10 }} onClick={() => onFilter()}> Filtra </Button>
//               <Button onClick={() => clearFilters()}> Rimuovi  </Button>
//             </Col>
//           </Row>
//         </>
//       )
//     }
//   ]

//   const exportSelectedDocuments = () => {
//     getSelectedDocuments();
//   };

//   const onSelectChange = (newSelectedRowKeys) => {
//     setSelectedRowKeys(newSelectedRowKeys);
//   };

//   const handleSelectPage = () => {
//     setHasAllSelection(false);
//     const selectedPageDocIds = documents.map(doc => doc.id);
//     setSelectedRowKeys(selectedPageDocIds);
//   };

//   const handleSelectAll = () => {
//     setHasAllSelection(true);
//     const allDocumentIds = documents.map(doc => doc.id);
//     setSelectedRowKeys(allDocumentIds);
//   };

//   const handleDeselectAll = () => {
//     setSelectedRowKeys([]);
//     setHasAllSelection(false);
//   };


//   const toggleCreateFluxModal = () => {
//     setShowDocumentFluxModal(true);
//   };

//   const handelCreateFlux = async (values) => {
//     const formData = new FormData();
//     formData.append("zipFile", values.file.file);
//     formData.append("operatorID", currentUser.id);

//     setLoadingFlux(true);
//     try {
//       const respData = await DocumentsServices.addDocumentFlux(formData);

//       if (respData.success) {
//         message.success(notifyMessages.addSuccess);
//         setShowDocumentFluxModal(false);
//         getDistinteDocuments(filterValues);
//       } else {
//         // Show backend error message
//         const errorMessage = respData?.errorDetail?.errorMessage || notifyMessages.errorAccured;
//         message.error(errorMessage);
//       }
//     } catch (error) {
//       message.error(notifyMessages.updateFailed);
//     } finally {
//       setLoadingFlux(false);
//     }
//   };

//   const rowSelection = {
//     selectedRowKeys,
//     preserveSelectedRowKeys: true,
//     onChange: onSelectChange,
//     columnWidth: "50px",
//   };

//   const hasSelected = selectedRowKeys.length > 0;
//   const selectedRowsCount = selectedRowKeys.length;

//   const items = (
//     [
//       {
//         key: '1',
//         label: (
//           <Text onClick={handleSelectPage}>Seleziona pagina</Text>
//         )
//       },
//       {
//         key: '2',
//         label: <Text onClick={handleSelectAll}>Seleziona tutto</Text>
//       }
//     ]);

//   return (
//     <>

//       {showDocumentFluxModal &&
//         <CreateDocumentFlux
//           showDocumentFluxModal={showDocumentFluxModal}
//           handelModalClose={() => setShowDocumentFluxModal(false)}
//           handelCreateFlux={handelCreateFlux}
//           loadingButton={loadingFlux}
//           operators={[]}
//         />
//       }

//       <PageHeader title="Distinte" />

//       <Row justify="center" align="top" gutter={[16, 16]} className='distinteDocuments'>

//         <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
//           <Collapse
//             size='small'
//             defaultActiveKey={['1']}
//             items={panelItems}
//           />
//         </Col>

//         <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
//           <Card className="docListButtons">
//             <Row justify="space-between" align="middle">
//               <Col>
//                 <Space size="middle">
//                   <Dropdown menu={{ items }}>
//                     <Button type="default">Seleziona {`(${selectedRowsCount})`}<DownOutlined /></Button>
//                   </Dropdown>
//                   <Button type="default" onClick={handleDeselectAll}>Deseleziona tutto</Button>
//                 </Space>
//               </Col>
//               {group2Rights(currentUser) && (
//                 <Col>
//                   <Space size="middle">
//                     <Button type="primary" onClick={() => toggleCreateFluxModal()} icon={<PlusOutlined />}>Carica flusso</Button>
//                     <Button type="primary" icon={<PlusOutlined />}><Link to={menuLinks.distinte + "/new"}>Carica documento</Link></Button>
//                   </Space>
//                 </Col>
//               )}
//             </Row>
//           </Card>
//         </Col>


//         <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
//           {/* <Card style={{ width: '100%' }} className="docListTable"> */}
//           <Card style={{ display: "inline-block", width: "100%" }} className="docListTable">
//             <Table
//               className='customTableRows'
//               bordered
//               rowClassName={(_, index) =>
//                 index % 2 === 0 ? 'table-row-light' : 'table-row-dark'
//               }
//               loading={loadingData}
//               dataSource={documents}
//               columns={columns}
//               rowKey={obj => obj.id}
//               rowSelection={rowSelection}
//               onChange={(pagination, filters, sorter) =>
//                 onPageOrOrderChange(pagination, filters, sorter)
//               }
//               pagination={{
//                 pageSize: tablePageSize,
//                 showSizeChanger: false,
//                 total: totalCountRecords || 0,
//                 current: pageNumber
//               }}
//               // tableLayout="fixed"
//               style={{ width: "auto" }}
//             />

//             <Row gutter={{ lg: 24 }}>
//               <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
//                 <div className="doc-bottom-button-wrapper">
//                   <Button type="primary" loading={loadingExcelDataExport} disabled={!hasSelected} onClick={getDocumentAttachments} className='mr10'> Scarica {`(${hasAllSelection ? totalCountRecords : selectedRowsCount})`}</Button>
//                   <Button type="primary" loading={loadingExcelDataExport} onClick={exportSelectedDocuments} disabled={!hasSelected} className='mr10'> Esporta {`(${hasAllSelection ? totalCountRecords : selectedRowsCount})`}</Button>
//                 </div>
//               </Col>
//             </Row>

//           </Card>

//         </Col>
//       </Row>
//     </>
//   );
// }

// export default DistinteDocumentList;


import { useEffect, useState } from 'react';
import { Col, Collapse, message, Popconfirm, Row, Select, Space, Table, Divider, Button, Card, DatePicker, Dropdown, Typography, Input } from 'antd';
import { dateFormat, menuLinks, notifyMessages, tablePageSize } from '../../utils/constants';
import { useDispatch, useSelector } from 'react-redux';
import { DeleteFilled, WarningOutlined, PlusOutlined, DownOutlined, MessageOutlined, EyeOutlined } from "@ant-design/icons";
import { useCurrentUserContext } from '../../context/currentUserContext';
import { Link } from "react-router-dom";
import "./distinteDocuments.scss";
import { PageHeader } from '../../components/common/pageHeader';
import { downloadSelectedDocPdfFiles, handleDateConvertForApis } from '../../utils/functions';
import DistinteDocumentServices from '../../services/distinteDocumentServices';
import dayjs from 'dayjs';
import * as XLSX from 'xlsx-js-style';
import * as FileSaver from "file-saver";
import { group1Rights, group2Rights } from '../../configs/auth/roleRights';
import { fetchSuppliersList } from '../../state/slices/suppliersListSlice';
import CreateDocumentFlux from '../documents/newDocumentFlux';
import DocumentsServices from '../../services/documentsServices';
import Filters from './filters';

const { RangePicker } = DatePicker;
const { Text } = Typography;

const DistinteDocumentList = () => {
  const FILTER_STORAGE_KEY = 'distinteDocumentsListFilters';
  const PAGE_STORAGE_KEY = 'distinteDocumentsListPage';
  const SORTER_STORAGE_KEY = 'distinteDocumentsListSorter';

  let filtersInitValues = {
    monthFrom: null,
    supplierID: null,
    monthTo: null,
    monthRange: null,
    regionId: null,
    flux: "",
    documentTypeDistinte: null,

    dateAddedFrom: null,
    dateAddedTo: null,
    dateAddedRange: null,

    lastUpdatedDateFrom: null,
    lastUpdatedDateTo: null,
    dateUpdatedRange: null
  };

  // Function to load filters from localStorage
  const loadFiltersFromStorage = () => {
    try {
      const savedFilters = localStorage.getItem(FILTER_STORAGE_KEY);
      if (savedFilters) {
        const parsedFilters = JSON.parse(savedFilters);
        // Validate that all expected filter keys exist
        const validatedFilters = { ...filtersInitValues };
        Object.keys(filtersInitValues).forEach(key => {
          if (parsedFilters.hasOwnProperty(key)) {
            // Handle date ranges properly
            if (key === 'dateAddedRange' || key === 'dateUpdatedRange' || key === 'monthRange') {
              if (parsedFilters[key] && Array.isArray(parsedFilters[key])) {
                validatedFilters[key] = parsedFilters[key].map(date => dayjs(date));
              }
            } else {
              validatedFilters[key] = parsedFilters[key];
            }
          }
        });
        return validatedFilters;
      }
    } catch (error) {
      console.error('Error loading filters from localStorage:', error);
    }
    return filtersInitValues;
  };

  // Function to save filters to localStorage
  const saveFiltersToStorage = (filters) => {
    try {
      // Convert dayjs objects to string format for storage
      const filtersToSave = { ...filters };
      if (filtersToSave.dateAddedRange && Array.isArray(filtersToSave.dateAddedRange)) {
        filtersToSave.dateAddedRange = filtersToSave.dateAddedRange.map(date =>
          date ? date.format() : null
        );
      }
      if (filtersToSave.dateUpdatedRange && Array.isArray(filtersToSave.dateUpdatedRange)) {
        filtersToSave.dateUpdatedRange = filtersToSave.dateUpdatedRange.map(date =>
          date ? date.format() : null
        );
      }
      if (filtersToSave.monthRange && Array.isArray(filtersToSave.monthRange)) {
        filtersToSave.monthRange = filtersToSave.monthRange.map(date =>
          date ? date.format() : null
        );
      }
      localStorage.setItem(FILTER_STORAGE_KEY, JSON.stringify(filtersToSave));
    } catch (error) {
      console.error('Error saving filters to localStorage:', error);
    }
  };

  // Function to load page number from localStorage
  const loadPageFromStorage = () => {
    try {
      const savedPage = localStorage.getItem(PAGE_STORAGE_KEY);
      if (savedPage) {
        const parsedPage = parseInt(savedPage, 10);
        return isNaN(parsedPage) || parsedPage < 1 ? 1 : parsedPage;
      }
    } catch (error) {
      console.error('Error loading page from localStorage:', error);
    }
    return 1;
  };

  // Function to save page number to localStorage
  const savePageToStorage = (page) => {
    try {
      localStorage.setItem(PAGE_STORAGE_KEY, page.toString());
    } catch (error) {
      console.error('Error saving page to localStorage:', error);
    }
  };

  // Function to load sorter from localStorage
  const loadSorterFromStorage = () => {
    try {
      const savedSorter = localStorage.getItem(SORTER_STORAGE_KEY);
      if (savedSorter) {
        return savedSorter;
      }
    } catch (error) {
      console.error('Error loading sorter from localStorage:', error);
    }
    return "";
  };

  // Function to save sorter to localStorage
  const saveSorterToStorage = (sorter) => {
    try {
      localStorage.setItem(SORTER_STORAGE_KEY, sorter);
    } catch (error) {
      console.error('Error saving sorter to localStorage:', error);
    }
  };

  // Function to clear all stored data
  const clearStorageData = () => {
    try {
      localStorage.removeItem(FILTER_STORAGE_KEY);
      localStorage.removeItem(PAGE_STORAGE_KEY);
      localStorage.removeItem(SORTER_STORAGE_KEY);
    } catch (error) {
      console.error('Error clearing storage data:', error);
    }
  };

  const dispatch = useDispatch();
  const { currentUser } = useCurrentUserContext();
  const regionsList = useSelector(state => state.regions.regions);

  const [documents, setDocuments] = useState([]);
  const [loadingData, setLoadingData] = useState(false);

  // Initialize state with data from localStorage
  const [pageNumber, setPageNumber] = useState(() => loadPageFromStorage());
  const [sorterColumn, setSorterColumn] = useState(() => loadSorterFromStorage());
  const [filterValues, setFilterValues] = useState(() => loadFiltersFromStorage());

  const [totalCountRecords, setTotalCountRecords] = useState(null);
  const [showDocumentFluxModal, setShowDocumentFluxModal] = useState(false);
  const [loadingFlux, setLoadingFlux] = useState(false);
  const documentTypesDistinteList = useSelector(state => state.docTypes.docTypesDistinte);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [hasAllSelection, setHasAllSelection] = useState(false);
  const [loadingExcelDataExport, setLoadingExcelDataExport] = useState(false);

  useEffect(() => {
    if (!currentUser) return;
    dispatch(fetchSuppliersList(currentUser.lastSelectedCategory, false, currentUser.id));
  }, [dispatch, currentUser]);

  // useEffect(() => {
  //   getDistinteDocuments(filterValues);
  // }, [pageNumber,
  //   sorterColumn,
  //   filterValues.monthRange,
  //   filterValues.regionId,
  //   filterValues.documentTypeDistinte,
  //   filterValues.dateAddedRange,
  //   filterValues.dateUpdatedRange]
  // );

  useEffect(() => {
    getDistinteDocuments();
  }, [pageNumber, sorterColumn, filterValues]);

  // Save to localStorage whenever filterValues change
  useEffect(() => {
    saveFiltersToStorage(filterValues);
  }, [filterValues]);

  // Save to localStorage whenever pageNumber changes
  useEffect(() => {
    savePageToStorage(pageNumber);
  }, [pageNumber]);

  // Save to localStorage whenever sorterColumn changes
  useEffect(() => {
    saveSorterToStorage(sorterColumn);
  }, [sorterColumn]);

  const getDistinteDocuments = async () => {

    let filterObj = filterValues;
    filterObj["pageNumber"] = pageNumber;
    filterObj["sortColumn"] = sorterColumn;
    filterObj["userID"] = currentUser.id;

    setLoadingData(true)
    try {
      const respData = await DistinteDocumentServices.getDistinteDocuments(filterObj);

      if (respData.success) {
        let result = respData.responseObject.value.document_Distinte_DTO;
        setDocuments(result);

        if (result && result.length > 0) {
          setTotalCountRecords(result[0].totalCount);
        }
        else {
          setTotalCountRecords(0);
        }


        if (hasAllSelection) {
          setSelectedRowKeys(result.map(doc => doc.id));
        }
      }

      setLoadingData(false);

    } catch (error) {
      message.error(notifyMessages.errorAccured);
      setLoadingData(false);
    }
  };

  const getSelectedDocuments = async () => {
    const docIds = hasAllSelection ? null : selectedRowKeys.join(",");
    // const payload = {
    //   sortColumn: sorterColumn && sorterColumn.trim() !== "" ? sorterColumn : "id",
    //   docIDsList: docIds,
    //   userID: currentUser.id
    // };

     const filterObj = {
      ...filterValues,
      sortColumn: sorterColumn,
      userID: currentUser.id,
      docIDsList: docIds
    };

    setLoadingExcelDataExport(true);
    try {
      const respData = await DistinteDocumentServices.getSelectedDocumentsList(filterObj);
      if (respData.success) {

        let result = respData.responseObject.value.documents;
        if (result && result.length > 0) {
          createExcelDataFile(result);
        }
        handleDeselectAll();
        setLoadingExcelDataExport(false);
      } else {
        message.error(notifyMessages.errorAccured);
        setLoadingExcelDataExport(false);
      }
    } catch (error) {
      message.error(notifyMessages.errorAccured);
      setLoadingExcelDataExport(false);
    }
  };

  const getDocumentAttachments = async () => {
    const docIds = hasAllSelection ? null : selectedRowKeys.join(",");

    const filterObj = {
      ...filterValues,
      sortColumn: sorterColumn,
      userID: currentUser.id,
      docIDsList: docIds
    };

    // setLoadingExcelDataExport(true)
    // let filterObj = filterValues;
    // filterObj["docIDsList"] = docIds;
    // filterObj['userID'] = currentUser.id;

    setLoadingExcelDataExport(true);
    try {
      const respData = await DistinteDocumentServices.getDocumentListAttachments(filterObj);
      if (respData.success) {
        let result = respData.responseObject.value.documents;
        if (result && result.length > 0) {
          setLoadingExcelDataExport(true);
          await downloadSelectedDocPdfFiles(result, "Esportazione-Portale");
          setLoadingExcelDataExport(false);
        }
        else {
          message.info(notifyMessages.noFileFound);
        }
        handleDeselectAll();
      }
      setLoadingExcelDataExport(false);
    } catch (error) {
      message.error(notifyMessages.errorAccured);
      setLoadingExcelDataExport(false);
    } finally{
      setLoadingExcelDataExport(false);
    }
  };

  const createExcelDataFile = (data) => {
    if (!data || data.length === 0) {
      message.info("Nessun dato trovato");
      return;
    }
    let formattedDocData = data.map((item) => ({
      Month: item.month,
      DateAdded: item.dateAdded ? dayjs(item.dateAdded).format(dateFormat) : "",
      RegionName: item.regionName,
      SupplierName: item.supplierName,
      flux: item.flux,
      documentTypeDistinteName: item.documentTypeDistinteName
    }));

    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const fileName = `ESPORTAZIONE-PORTALE-${dayjs().format(dateFormat)}`;
    // Define headers
    const headers = [["Mese", "Data Caricamento", "CNA Provinciale", "Rag.Soc.Manut", "Batch", "Tipo"],
    ];
    const ws = XLSX.utils.json_to_sheet([]);
    XLSX.utils.sheet_add_json(ws, formattedDocData, { origin: "A2", skipHeader: true });
    XLSX.utils.sheet_add_aoa(ws, headers);
    const wb = { Sheets: { "Esportazione Fatture": ws }, SheetNames: ["Esportazione Fatture"] };
    // Set column width
    ws["!cols"] = Array(25).fill({ wpx: 200 });
    // Apply bold style to headers
    for (let key in ws) {
      if (typeof ws[key] !== "object") continue;
      let cell = XLSX.utils.decode_cell(key);
      if (cell.r === 1) {
        let p = key.replace("2", "1");
        ws[p].s = { font: { bold: true } };
      }
    }
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const dataBlob = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(dataBlob, fileName + fileExtension);
  };

  const onPageOrOrderChange = (pagination, filters, sorter) => {
    setPageNumber(pagination.current);
    if (sorter && sorter.field) {
      let sorterQuote = "";
      if (sorter.order === "descend") {
        sorterQuote = "[" + sorter.field + "]" + " " + "DESC";
      }
      if (sorter.order === "ascend") {
        sorterQuote = "[" + sorter.field + "]" + " " + "ASC";
      }
      setSorterColumn(sorterQuote);
    } else {
      setSorterColumn("");
    }
  };

  const onFilter = () => {
    getDistinteDocuments();
    setPageNumber(1);
  };

  const clearFilters = () => {
    // setPageNumber(1);
    // setFilterValues(filtersInitValues);
    // getDistinteDocuments(filtersInitValues);
    // // Clear localStorage when filters are cleared
    // clearStorageData();

    setPageNumber(1);
    setFilterValues(filtersInitValues);
    // Clear localStorage when filters are cleared
    clearStorageData();
  };

  const filterData = (values) => {
    setFilterValues(values);
    setPageNumber(1); // Reset to first page when applying new filters
  };

  const handelFilterChange = (name, value) => {
    if (name === "dateAdded") {
      let startDateAdded = handleDateConvertForApis(value[0].$d);
      let endDateAdded = handleDateConvertForApis(value[1].$d);
      setFilterValues((prev) => ({ ...prev, dateAddedFrom: startDateAdded }));
      setFilterValues((prev) => ({ ...prev, dateAddedTo: endDateAdded }));
      setFilterValues((prev) => ({ ...prev, dateAddedRange: value }));
    }
    else if (name === "dateUpdated") {
      let startDateUpdated = handleDateConvertForApis(value[0].$d);
      let endDateUpdated = handleDateConvertForApis(value[1].$d);
      setFilterValues((prev) => ({ ...prev, lastUpdatedDateFrom: startDateUpdated }));
      setFilterValues((prev) => ({ ...prev, lastUpdatedDateTo: endDateUpdated }));
      setFilterValues((prev) => ({ ...prev, dateUpdatedRange: value }));
    }
    else if (name === "month") {
      let monthFrom = handleDateConvertForApis(value[0].$d);
      let monthTo = handleDateConvertForApis(value[1].$d);
      setFilterValues((prev) => ({ ...prev, monthFrom: monthFrom }));
      setFilterValues((prev) => ({ ...prev, monthTo: monthTo }));
      setFilterValues((prev) => ({ ...prev, monthRange: value }));
    }
    else {
      setFilterValues((prev) => ({ ...prev, [name]: value }));
    }
  }

  const onDocumentPdfView = async (documentId) => {
    message.warning(notifyMessages.generateDocumentPdfLoading);
    try {
      const respData = await DistinteDocumentServices.readDocumentPDF(documentId);
      if (respData.success) {
        let pdfData = respData.responseObject.value;
        if (pdfData.documentPdfURI) {
          // handle and convert base64 to PDF
          let base64str = pdfData.pdfArray;
          let binary = atob(base64str.replace(/\s/g, ""));
          let len = binary.length;
          let buffer = new ArrayBuffer(len);
          let view = new Uint8Array(buffer);
          for (let i = 0; i < len; i++) {
            view[i] = binary.charCodeAt(i);
          }
          // create the blob object with content-type "application/pdf"
          let blob = new Blob([view], { type: "application/pdf" });
          let url = URL.createObjectURL(blob);
          window.open(url, "Document", "width=800,height=600");
        } else {
          message.error(notifyMessages.noFileFound);
        }
      } else {
        message.error(notifyMessages.errorAccured);
      }
    } catch (error) {
      message.error(notifyMessages.errorAccured);
    }
  };

  const onRemoveDocument = async (documentId) => {
    try {
      const respData = await DistinteDocumentServices.deleteDocument(documentId);
      if (respData.success) {
        message.success(notifyMessages.operationSuccess);
        getDistinteDocuments();
      } else {
        message.error(notifyMessages.errorAccured);
      }
    } catch (error) {
      message.error(notifyMessages.errorAccured);
    }
  };

  const columns = [
    {
      title: "Opzioni",
      key: "actions",
      width: "150px",
      render: (_, record) => (
        <Space size="middle">
          <EyeOutlined style={{ color: "#023B72", marginRight: "5px" }} onClick={() => onDocumentPdfView(record.id)} />
          <MessageOutlined style={{ color: record.notesViewed ? 'green' : 'red' }} />
          <Link style={{ color: "#0f4d65" }} to={{ pathname: `${menuLinks.distinte}/view/id/${record.id}` }}>Apri</Link>
        </Space>
      ),
      onCell: () => ({
        style: {
          whiteSpace: "nowrap", // prevent wrapping
        },
      }),
      width: 1, // let browser auto-size to content
    },
    {
      title: "Ragione Sociale",
      dataIndex: "supplierName",
      key: "supplierName",
      sorter: (a, b) => {
        a = a.supplierName || "";
        b = b.supplierName || "";
        return a.localeCompare(b);
      },
      showSorterTooltip: false,
      className: 'doc-table-wrap-cell'
    },
        {
      title: "Partita IVA",
      dataIndex: "supplierVatCode",
      key: "supplierVatCode",
      sorter: (a, b) => {
        a = a.supplierVatCode || "";
        b = b.supplierVatCode || "";
        return a.localeCompare(b);
      },
      showSorterTooltip: false,
      // className: 'doc-table-wrap-cell'
      onCell: () => ({
        style: {
          whiteSpace: "nowrap", // prevent wrapping
        },
      }),
      width: 1, // let browser auto-size to content
    },

    {
      title: "CNA Provinciale",
      dataIndex: "regionName",
      key: "regionName",
      sorter: (a, b) => {
        a = a.regionName || "";
        b = b.regionName || "";
        return a.localeCompare(b);
      },
      showSorterTooltip: false,
      className: 'doc-table-wrap-cell'
    },
    {
      title: "Mese",
      dataIndex: "month",
      key: "month",
      sorter: (a, b) => {
        const dateA = dayjs(a.month, 'MM');
        const dateB = dayjs(b.month, 'MM');
        return dateA.isBefore(dateB) ? -1 : dateA.isAfter(dateB) ? 1 : 0;
      },
      showSorterTooltip: false,
      render: (text, record) => (text ? dayjs(text).format("MM/YYYY") : ""),
      onCell: () => ({
        style: {
          whiteSpace: "nowrap", // prevent wrapping
        },
      }),
      width: 1, // let browser auto-size to content
      // className: 'doc-table-wrap-cell'
    },
    {
      title: "Batch",
      dataIndex: "flux",
      key: "flux",
      sorter: (a, b) => {
        a = a.flux || "";
        b = b.flux || "";
        return a.localeCompare(b);
      },
      showSorterTooltip: false,
      className: 'doc-table-wrap-cell'
    },
    {
      title: "Tipo",
      dataIndex: "documentTypeDistinteName",
      key: "documentTypeDistinteName",
      sorter: (a, b) => {
        a = a.documentTypeDistinteName || "";
        b = b.documentTypeDistinteName || "";
        return a.localeCompare(b);
      },
      showSorterTooltip: false,
      className: 'doc-table-wrap-cell'
    },
    {
      title: "Data caricamento",
      dataIndex: "dateAdded",
      key: "dateAdded",
      sorter: (a, b) => {
        a = a.dateAdded || "";
        b = b.dateAdded || "";
        return a.localeCompare(b);
      },
      showSorterTooltip: false,
      render: (text) => (text ? dayjs(text).format(dateFormat) : ""),
      onCell: () => ({
        style: {
          whiteSpace: "nowrap", // prevent wrapping
        },
      }),
      width: 1, // let browser auto-size to content
      // className: 'doc-table-wrap-cell'
    },
    {
      key: "action3",
      width: "50px",
      render: (_, record) => {
        return (
          <>
            {group1Rights(currentUser) && (
              <Popconfirm
                placement="topRight"
                key="remove"
                title="Vuoi eliminare questo documento?"
                icon={<WarningOutlined style={{ color: "#f7c924" }} />}
                okText="Si"
                cancelText="No"
                onConfirm={() => onRemoveDocument(record.id)}
              >
                <DeleteFilled style={{ color: "#023B72" }} title={"Elimina Documento"} />
              </Popconfirm>
            )}
          </>
        );
      },
    },
  ]

  const totalPages = Math.ceil(totalCountRecords / tablePageSize);

  const panelItems = [
    {
      key: '1',
      label: `Filtra documenti - Visualizzando ${totalCountRecords ? totalCountRecords : ""} documenti (Pagina: ${pageNumber}/${totalPages})`,
      children: (
        <>
          <Row gutter={{ lg: 24 }}>


            <Col className="gutter-row mb10" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 4 }}>
              <Space direction='vertical' style={{ width: "100%" }}>
                <span>Mese</span>
                <RangePicker
                  value={filterValues.monthRange}
                  picker="month"
                  style={{ width: "100%" }}
                  format={'MM/YYYY'}
                  placeholder={["Mese inizio", 'Mese fine']}
                  onChange={(dates) => handelFilterChange("month", dates)}
                />
              </Space>
            </Col>

            <Col className="gutter-row mb10" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 4 }}>
              <Space direction='vertical' style={{ width: "100%" }}>
                <span>CNA Provinciale</span>
                <Select
                  value={filterValues.regionId}
                  style={{ width: "100%" }}
                  showSearch
                  optionFilterProp="label"
                  placeholder="CNA Provinciale"
                  allowClear
                  options={regionsList}
                  onSelect={(value) => handelFilterChange("regionId", value)}
                  onClear={() => handelFilterChange("regionId", null)}
                />
              </Space>
            </Col>

            <Col className="gutter-row mb10" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 4 }}>
              <Space direction='vertical' style={{ width: "100%" }}>
                <span>Tipo</span>
                <Select
                  value={filterValues.documentTypeDistinte}
                  style={{ width: "100%" }}
                  showSearch
                  optionFilterProp="label"
                  placeholder="Tipo"
                  allowClear
                  options={documentTypesDistinteList}
                  onSelect={(value) => handelFilterChange("documentTypeDistinte", value)}
                  onClear={() => handelFilterChange("documentTypeDistinte", null)}
                />
              </Space>
            </Col>

            <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 4 }}>
              <Space direction='vertical' style={{ width: "100%" }}>
                <span>Batch</span>
                <Input value={filterValues.flux} placeholder='Batch' onChange={(e) => handelFilterChange("flux", e.target.value)} />
              </Space>
            </Col>

            <Col className="gutter-row mb10" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 4 }}>
              <Space direction='vertical' style={{ width: "100%" }}>
                <span>Data caricamento</span>
                <RangePicker
                  value={filterValues.dateAddedRange}
                  style={{ width: "100%" }}
                  format={dateFormat}
                  placeholder={["Data inizio", 'Data fine']}
                  onChange={(dates) => handelFilterChange("dateAdded", dates)}
                  allowClear={false}
                />
              </Space>
            </Col>

            <Col className="gutter-row mb10" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 4 }}>
              <Space direction='vertical' style={{ width: "100%" }}>
                <span>Data modifica</span>
                <RangePicker
                  value={filterValues.dateUpdatedRange}
                  style={{ width: "100%" }}
                  format={dateFormat}
                  placeholder={["Data inizio", 'Data fine']}
                  onChange={(dates) => handelFilterChange("dateUpdated", dates)}
                  allowClear={false}
                />
              </Space>
            </Col>

          </Row>
          <Divider />
          <Row gutter={{ lg: 24 }}>
            <Col className="gutter-row fliterButtons" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
              <Button type="primary" style={{ marginRight: 10 }} onClick={() => onFilter()}> Filtra </Button>
              <Button onClick={() => clearFilters()}> Rimuovi  </Button>
            </Col>
          </Row>
        </>
      )
    }
  ]

  const exportSelectedDocuments = () => {
    getSelectedDocuments();
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const handleSelectPage = () => {
    setHasAllSelection(false);
    const selectedPageDocIds = documents.map(doc => doc.id);
    setSelectedRowKeys(selectedPageDocIds);
  };

  const handleSelectAll = () => {
    setHasAllSelection(true);
    const allDocumentIds = documents.map(doc => doc.id);
    setSelectedRowKeys(allDocumentIds);
  };

  const handleDeselectAll = () => {
    setSelectedRowKeys([]);
    setHasAllSelection(false);
  };

  const toggleCreateFluxModal = () => {
    setShowDocumentFluxModal(true);
  };

  const handelCreateFlux = async (values) => {
    const formData = new FormData();
    formData.append("zipFile", values.file.file);
    formData.append("operatorID", currentUser.id);

    setLoadingFlux(true);
    try {
      const respData = await DocumentsServices.addDocumentFlux(formData);

      if (respData.success) {
        message.success(notifyMessages.addSuccess);
        setShowDocumentFluxModal(false);
        getDistinteDocuments();
      } else {
        // Show backend error message
        const errorMessage = respData?.errorDetail?.errorMessage || notifyMessages.errorAccured;
        message.error(errorMessage);
      }
    } catch (error) {
      message.error(notifyMessages.updateFailed);
    } finally {
      setLoadingFlux(false);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    preserveSelectedRowKeys: true,
    onChange: onSelectChange,
    columnWidth: "50px",
  };

  const hasSelected = selectedRowKeys.length > 0;
  const selectedRowsCount = selectedRowKeys.length;

  const items = (
    [
      {
        key: '1',
        label: (
          <Text onClick={handleSelectPage}>Seleziona pagina</Text>
        )
      },
      {
        key: '2',
        label: <Text onClick={handleSelectAll}>Seleziona tutto</Text>
      }
    ]);

  return (
    <>

      {showDocumentFluxModal &&
        <CreateDocumentFlux
          showDocumentFluxModal={showDocumentFluxModal}
          handelModalClose={() => setShowDocumentFluxModal(false)}
          handelCreateFlux={handelCreateFlux}
          loadingButton={loadingFlux}
          operators={[]}
        />
      }

      <PageHeader title="Distinte" />

      <Row justify="center" align="top" gutter={[16, 16]} className='distinteDocuments'>

        {/* <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
          <Collapse
            size='small'
            defaultActiveKey={['1']}
            items={panelItems}
          />
        </Col> */}

        <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
          <Filters
            onFilterData={filterData}
            onResetData={clearFilters}
            filterValues={filterValues}
            filtersInitValues={filtersInitValues}
            totalDocNr={totalCountRecords}
            pageNumber={pageNumber}
            pageSize={tablePageSize}
          />
        </Col>

        <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
          <Card className="docListButtons">
            <Row justify="space-between" align="middle">
              <Col>
                <Space size="middle">
                  <Dropdown menu={{ items }}>
                    <Button type="default">Seleziona {`(${selectedRowsCount})`}<DownOutlined /></Button>
                  </Dropdown>
                  <Button type="default" onClick={handleDeselectAll}>Deseleziona tutto</Button>
                </Space>
              </Col>
              {group2Rights(currentUser) && (
                <Col>
                  <Space size="middle">
                    <Button type="primary" onClick={() => toggleCreateFluxModal()} icon={<PlusOutlined />}>Carica flusso</Button>
                    <Button type="primary" icon={<PlusOutlined />}><Link to={menuLinks.distinte + "/new"}>Carica documento</Link></Button>
                  </Space>
                </Col>
              )}
            </Row>
          </Card>
        </Col>


        <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
          {/* <Card style={{ width: '100%' }} className="docListTable"> */}
          <Card style={{ display: "inline-block", width: "100%" }} className="docListTable">
            <Table
              className='customTableRows'
              bordered
              rowClassName={(_, index) =>
                index % 2 === 0 ? 'table-row-light' : 'table-row-dark'
              }
              loading={loadingData}
              dataSource={documents}
              columns={columns}
              rowKey={obj => obj.id}
              rowSelection={rowSelection}
              onChange={(pagination, filters, sorter) =>
                onPageOrOrderChange(pagination, filters, sorter)
              }
              pagination={{
                pageSize: tablePageSize,
                showSizeChanger: false,
                total: totalCountRecords || 0,
                current: pageNumber
              }}
              // tableLayout="fixed"
              style={{ width: "auto" }}
            />

            <Row gutter={{ lg: 24 }}>
              <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                <div className="doc-bottom-button-wrapper">
                  <Button type="primary" loading={loadingExcelDataExport} disabled={!hasSelected} onClick={getDocumentAttachments} className='mr10'> Scarica {`(${hasAllSelection ? totalCountRecords : selectedRowsCount})`}</Button>
                  <Button type="primary" loading={loadingExcelDataExport} onClick={exportSelectedDocuments} disabled={!hasSelected} className='mr10'> Esporta {`(${hasAllSelection ? totalCountRecords : selectedRowsCount})`}</Button>
                </div>
              </Col>
            </Row>

          </Card>

        </Col>
      </Row>
    </>
  );
}

export default DistinteDocumentList;